import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class ConsultantService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.CONSULTANTS(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.CONSULTANTS_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.CONSULTANTS(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.CONSULTANTS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.CONSULTANTS(id), data);
    }

    updateProfile(id, data): Observable<any> {
        return this.putRequest(AppUrl.CONSULTANT_PROFILE_IMAGE(id), data);
    }

    updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.CONSULTANT_PASSWORD(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.CONSULTANT_STATUS(id), data);
    }

    assign_doctor(id, data): Observable<any> {
        return this.putRequest(AppUrl.ASSIGN_DOCTORS(id), data);
    }
}
